import styled from 'styled-components'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import { OUTLINE_COLOR, FONT_BASE_COLOR } from '@CSSVars/colors'


export const _MapBoxZoomControl = styled.div.attrs({
  className: 'zoomControl',
})`
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 25px;
  right: 10px;
  z-index: 100;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  svg {
    fill: ${FONT_BASE_COLOR};
  }
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    width: 36px;
    height: 44px;
    &:last-child {
      border-top: 1px solid ${OUTLINE_COLOR};
    }
    &:hover {
      cursor: pointer;
    }
  }
  ${({ nearbyListingMap }) => (nearbyListingMap && `
    @media screen and (max-width: ${BREAK_POINT_MD}) {
      bottom: initial;
      top: 24px;
      right: 10px;
    }
  `)}
  ${({ galleryModal }) => (galleryModal && `
    right: 420px;
    @media screen and (max-width: calc(${BREAK_POINT_LG} - 1px)) {
      right: 10px;
    }
  `)}
`
